module.exports = __webpack_public_path__ + "e7ad47ed9013f0bae55e898a2a7a714f.svg";